module.exports = __webpack_public_path__ + "img/generic-error.svg";